export default function CreditCardIcon({ size = 42 }) {
    return (
        <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M33 16L33 20L7 20L7 16L33 16Z" fill="url(#paint0_linear_208_128)" />
            <path d="M37 25.0762L37 20L33 20L33 25.0762C33 27.2642 31.2091 29 29 29L28 29L28 31L28 33L29 33C33.4183 33 37 29.4524 37 25.0762Z" fill="url(#paint1_linear_208_128)" />
            <rect width="3" height="4" transform="matrix(4.37114e-08 1 1 -4.37114e-08 33 17)" fill="black" />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M24 8L29.0762 8C33.4524 8 37 11.5817 37 16V17L33 17V16C33 13.7909 31.2642 12 29.0762 12L24 12H16L10.9238 12C8.73575 12 7 13.7909 7 16V24V25C7 27.2091 8.73575 29 10.9238 29H16H28V33H16H10.9238C6.54759 33 3 29.4183 3 25V24V16C3 11.5817 6.54759 8 10.9238 8L16 8H24Z"
                fill="black"
            />
            <defs>
                <linearGradient id="paint0_linear_208_128" x1="33" y1="18" x2="7.86663" y2="18" gradientUnits="userSpaceOnUse">
                    <stop offset="0.509095" />
                    <stop offset="1" stopOpacity="0" />
                </linearGradient>
                <linearGradient id="paint1_linear_208_128" x1="32.5" y1="29.5" x2="35" y2="21" gradientUnits="userSpaceOnUse">
                    <stop />
                    <stop offset="1" stopColor="#666666" stopOpacity="0" />
                </linearGradient>
            </defs>
        </svg>
    );
}
